import { SegmentInputTextState, SegmentState } from './model';

export const initialSegmentState: SegmentState = {
	userCTDPayoutSegments: [],
	ctdUserSegmentPriorityList: [],
	ctdAmountLimitSegmentList: [],
	withdrawFeeSegmentList: [],
	payoutAmountLimitSegmentList: [],
	coolOffSegmentList: [],
	ctdCoolOffSegmentList: [],
	payoutCoolOffSegmentList: [],
	leaveIntentSegmentList: []
};
export const initialSegmentInputTextState: SegmentInputTextState = {
	userCTDPayoutSegments: '',
	ctdUserSegmentPriorityList: '',
	withdrawFeeSegmentList: '',
	ctdAmountLimitSegmentList: '',
	payoutAmountLimitSegmentList: '',
	coolOffSegmentList: '',
	payoutCoolOffSegmentList: '',
	ctdCoolOffSegmentList: '',
	leaveIntentSegmentList: ''
};
